/**
 * Learner account id: R{rsoId}-{learnerId} or C{companyId}-{learnerId} (e.g. C0000000001-00001). Same rule as the backend parser.
 */
export const LEARNER_ACCOUNT_ID_REGEX = /^[RC]\d+-\d+$/i;

export const isValidLearnerAccountId = (accountId: string | null | undefined): boolean => {
  if (!accountId) return false;
  return LEARNER_ACCOUNT_ID_REGEX.test(accountId);
};
